import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Advantages } from './components/Advantages';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-primary" data-id="element-0" data-mp="2rit335f91uqf">
      <Navbar data-id="element-1" data-mp="2mmvnx2fq2uf8" />
      <main data-id="element-2" data-mp="2mndryl8mmcxp">
        <Hero data-id="element-3" data-mp="2mjpuxc3z38e8" />
        <Advantages data-id="element-4" data-mp="2mjzmv58kvpmk" />
        <Services data-id="element-5" data-mp="31b8jhyaweb97" />
        <Testimonials data-id="element-6" data-mp="31bs27h8dh3oa" />
        <FAQ data-id="element-7" data-mp="31c9uk2rwyxqx" />
        <Contact data-id="element-8" data-mp="31ctdnmtavs6j" />
      </main>
      <Footer data-id="element-9" data-mp="2wk9zooqpav17" />
    </div>;
}